function e(e){return typeof e==`string`}export{e as isString};
//# sourceMappingURL=isString-BPlksnnG.js.map